import { Injectable } from '@angular/core';
import { ApiService } from '@app/services/api.service';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';

interface SnapshotInterface {
    id: string;
    mimeType: string;
    originalName: string;
    size: number;
    thumbnail: string;
    userId: string;
}

export class Snapshot {
    constructor(
        public id: string,
        public mimeType: string,
        public originalName: string,
        public size: number,
        public thumbnail: string,
        public userId: string
    ) {}
}

interface SavedSnapshotInterface {
    oldId: string;
    newId: string;
    ok: boolean;
    result: string;
    snapshot: Snapshot;
}

export function isSavedSnapshotInterface(obj: any): obj is SavedSnapshotInterface {
    return obj && 'oldId' in obj && 'newId' in obj && 'ok' in obj && 'result' in obj && 'snapshot' in obj;
}

export class SavedSnapshot implements SavedSnapshotInterface {
    constructor(
        public oldId: string,
        public newId: string,
        public ok: boolean,
        public result: string,
        public snapshot: Snapshot
    ) {}
}

@Injectable({
    providedIn: 'root',
})
export class SnapshotsService extends ApiService<Snapshot> {
    protected serviceName = 'file/snapsend';
    private SNAP_MOVE_URL = 'file/snapmove';
    private SNAP_GET_URL = 'file/snapget';

    createdSnapshotSubject: Subject<Snapshot> = new Subject();
    public createdSnapshots$: Observable<Snapshot> = this.createdSnapshotSubject.asObservable();

    constructor() {
        super();
        this.initConnection();
    }

    override _created(snapshot: SnapshotInterface) {
        this.createdSnapshotSubject.next(
            new Snapshot(
                snapshot.id,
                snapshot.mimeType,
                snapshot.originalName,
                snapshot.size,
                snapshot.thumbnail,
                snapshot.userId
            )
        );
    }

    public async saveSnapshot(snapshot: Snapshot): Promise<SavedSnapshot> {
        // @ts-expect-error - this is a valid call

        // @API file/snapmove
        const response: SavedSnapshotInterface[] = await this.backendService
            .getService<SavedSnapshot>(this.SNAP_MOVE_URL)
            // @ts-expect-error - this is a valid call
            .create([snapshot.id]);

        return new SavedSnapshot(response[0].oldId, response[0].newId, response[0].ok, response[0].result, snapshot);
    }
}
